import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Coupon = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
export const CouponInfo = styled.View``;

export const CouponTitle = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
`;
export const ButtonLinkRow = styled.View`
  flex-direction: row;
`;
export const ButtonLinkContainer = styled.TouchableOpacity`
  border-style: solid;
  border-color: ${({theme}) => theme.colors.blue};
  border-bottom-width: 2px;
  align-items: center;
  flex-direction: row;
`;
export const ButtonLinkText = styled.Text`
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  margin-top: ${RFValue(8)}px;
`;
export const RemoveCouponButton = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
`;
export const RemoveText = styled.Text`
  color: ${({theme}) => theme.colors.red};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
`;

export const CouponAlert = styled.View`
  margin-top: ${RFValue(12)}px;
  padding: ${RFValue(8)}px ${RFValue(12)}px;
  background: ${({theme}) => theme.colors.yellow};
  border-radius: ${RFValue(8)}px;
`;

export const CouponAlertText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
`;
